
import { Component, Vue, Watch } from "vue-property-decorator";
import AdminTable from "@/components/admin/AdminTable.vue";
import gql from "graphql-tag";
import copyToClipboard from 'quasar/src/utils/copy-to-clipboard.js';;

@Component({
  components: {
    AdminTable
  }
})
export default class AdminSteamBotProxy extends Vue {
  proxyType = true;
  creationProxyList = "";
  creationProxyComment = "";
  creationProxyDialog = false;
  buyProxyDialog = false;
  proxylineBalance = "";
  proxylineBuyAmount = "";
  proxyPeriod = "";
  proxyCount = "";
  proxyCountry = "";
  onlyCopy = false;
  isAimCopyFormat = false;
  proxyCountryList = [
    { label: "Россия", value: "ru" },
    { label: "Казахстан", value: "kz" },
    { label: "Украина", value: "ua" },
    { label: "Германия", value: "de" },
    { label: "США", value: "us" },
    { label: "Норвегия", value: "no" },
    { label: "Maldives", value: "mv" },
    { label: "France", value: "fr" },
    { label: "Switzerland", value: "ch" },
    { label: "Portugal", value: "pt" },
    { label: "China", value: "cn" },
    { label: "Poland", value: "pl" },
    { label: "Canada", value: "ca" },
    { label: "United Kingdom", value: "gb" },
    { label: "Netherland", value: "nl" },
    { label: "Spain", value: "es" },
    { label: "Italy", value: "it" },
    { label: "Indonesia", value: "id" },
    { label: "India", value: "in" },
    { label: "Japan", value: "jp" },
    { label: "Abkhazia", value: "ab" },
    { label: "Australia", value: "au" },
    { label: "Austria", value: "at" },
    { label: "Azerbaijan", value: "az" },
    { label: "Albania", value: "al" },
    { label: "Algeria", value: "dz" },
    { label: "Argentina", value: "ar" },
    { label: "Armenia", value: "am" },
    { label: "Bangladesh", value: "bd" },
    { label: "Belarus", value: "by" },
    { label: "Belgium", value: "be" },
    { label: "Bulgaria", value: "bg" },
    { label: "Bolivia", value: "bo" },
    { label: "Bosnia and Herzegovina", value: "ba" },
    { label: "Brazil", value: "br" },
    { label: "Hungary", value: "hu" },
    { label: "Venezuela", value: "ve" },
    { label: "Vietnam", value: "vn" },
    { label: "Hong Kong", value: "hk" },
    { label: "Greece", value: "gr" },
    { label: "Georgia", value: "ge" },
    { label: "Denmark", value: "dk" },
    { label: "Egypt", value: "eg" },
    { label: "Zambia", value: "zm" },
    { label: "Israel", value: "il" },
    { label: "Jordan", value: "jo" },
    { label: "Iraq", value: "iq" },
    { label: "Iran", value: "ir" },
    { label: "Ireland", value: "ie" },
    { label: "Iceland", value: "is" },
    { label: "Cambodia", value: "kh" },
    { label: "Cameroon", value: "cm" },
    { label: "Qatar", value: "qa" },
    { label: "Kenya", value: "ke" },
    { label: "Cyprus", value: "cy" },
    { label: "Colombia", value: "co" },
    { label: "Korea", value: "kr" },
    { label: "Costa Rica", value: "cr" },
    { label: "Ivory Coast", value: "ci" },
    { label: "Cuba", value: "cu" },
    { label: "Kyrgyzstan", value: "kg" },
    { label: "Latvia", value: "lv" },
    { label: "Lebanon", value: "lb" },
    { label: "Libya", value: "ly" },
    { label: "Lithuania", value: "lt" },
    { label: "Luxembourg", value: "lu" },
    { label: "Malaysia", value: "my" },
    { label: "Malta", value: "mt" },
    { label: "Morocco", value: "ma" },
    { label: "Mexico", value: "mx" },
    { label: "Moldova", value: "md" },
    { label: "Monaco", value: "mc" },
    { label: "Mongolia", value: "mn" },
    { label: "Nepal", value: "np" },
    { label: "Nigeria", value: "ng" },
    { label: "New Zealand", value: "nz" },
    { label: "United Arab Emirates", value: "ae" },
    { label: "Pakistan", value: "pk" },
    { label: "Paraguay", value: "py" },
    { label: "Peru", value: "pe" },
    { label: "Romania", value: "ro" },
    { label: "Saudi Arabia", value: "sa" },
    { label: "Seychelles", value: "sc" },
    { label: "Serbia", value: "rs" },
    { label: "Singapore", value: "sg" },
    { label: "Slovakia", value: "sk" },
    { label: "Slovenia", value: "si" },
    { label: "Tajikistan", value: "tj" },
    { label: "Taiwan", value: "tw" },
    { label: "Thailand", value: "th" },
    { label: "Tanzania", value: "tz" },
    { label: "Tunisia", value: "tn" },
    { label: "Turkmenistan", value: "tm" },
    { label: "Turkey", value: "tr" },
    { label: "Uzbekistan", value: "uz" },
    { label: "Uruguay", value: "uy" },
    { label: "Philippines", value: "ph" },
    { label: "Finland", value: "fi" },
    { label: "Croatia", value: "hr" },
    { label: "Montenegro", value: "me" },
    { label: "Czech Republic", value: "cz" },
    { label: "Chile", value: "cl" },
    { label: "Sweden", value: "se" },
    { label: "Sri Lanka", value: "lk" },
    { label: "Estonia", value: "ee" },
    { label: "Ethiopia", value: "et" },
    { label: "South Africa", value: "za" },
    { label: "South Sudan", value: "sd" },
    { label: "Jamaica", value: "jm" }
  ];
  columns = [
    {
      name: "_id",
      required: true,
      label: "Steam ID",
      field: "_id",
      align: "left",
      type: "string"
    },
    {
      name: "url",
      align: "center",
      label: "url",
      field: "url",
      editable: true,
      type: "string"
    },
    {
      name: "steamBotId",
      align: "center",
      label: "steamBotId",
      field: "steamBotId",
      editable: true,
      type: "string"
    },
    {
      name: "comment",
      align: "center",
      label: "Комментарий",
      field: "comment",
      editable: true,
      type: "string"
    },
    {
      name: "enabled",
      align: "center",
      label: "enabled",
      field: "enabled",
      editable: true,
      type: "boolean"
    },
    {
      name: "rotator",
      align: "center",
      label: "rotator",
      field: "rotator",
      editable: true,
      type: "boolean"
    }
  ];

  async openBuyDialog() {
    this.buyProxyDialog = true;

    const { data } = await this.$apollo.query({
      query: gql`
        query {
          getProxylineBalance
        }
      `
    });

    this.proxylineBalance = data.getProxylineBalance;
  }

  @Watch("proxyCountry")
  @Watch(`proxyCount`)
  @Watch(`proxyPeriod`)
  async getOrderAmount() {
    if (this.proxyCountry && this.proxyCount && this.proxyPeriod) {
      const { data } = await this.$apollo.query({
        query: gql`
          query($period: String!, $count: String!, $country: String!) {
            getAmountBuySteamBotProxy(
              period: $period
              count: $count
              country: $country
            )
          }
        `,
        variables: {
          period: String(this.proxyPeriod),
          count: this.proxyCount,
          country: (this.proxyCountry as any).value
        }
      });

      this.proxylineBuyAmount = data.getAmountBuySteamBotProxy;
    }
  }

  async copyToClipboard(value) {
    return await copyToClipboard(value);
  }

  async submit(mutate) {
    const urls = this.creationProxyList.split("\n").map(proxy => {
      const [ip, port, login, password] = proxy.split(":");

      if (this.proxyType) {
        return `socks5://${login ? `${login}:${password}@` : ""}${ip}:${port}`;
      } else {
        return `http://${login ? `${login}:${password}@` : ""}${ip}:${port}`;
      }
    });

    for await (const url of urls) {
      try {
        await mutate({
          variables: { url, comment: this.creationProxyComment }
        });
      } catch (e) {
        console.error(e);
      }
    }
  }
}
